import { Injectable } from "@angular/core";
import { FilterConfig } from "../models/filter-config";
import { FilterOption } from "../models/filter-option.model";
import { FilterDisplay } from "../models/filter-display.enum";

@Injectable({
  providedIn: 'root'
})
export class filterDisplayService {
  public getDisplayValue(
    config: FilterConfig
  ): string[] {
    if(config.consolidado){
      return [config.textoConsolidado];
    }

    const selected = this.getSelected(config.options);

    if(!selected.length){
      return config.display.placeholder ? [`${config.display.placeholder}`] : [''];
    }

    switch( config.display.mode){
      case FilterDisplay.LABEL:
        return [`${this.label(selected)}`];

      case FilterDisplay.COUNT:
        return [`${this.count(selected)}`];

      case FilterDisplay.LABEL_PLUS_COUNT:
        return this.labelPlusCount(
          selected,
          config.display.maxLabels ?? 1
        );

      case FilterDisplay.AUTO:
      default:
        return this.auto(selected, config.display.maxLabels ?? 1);

    }
  }
  /**
   * Obtiene todos los elementos seleccionados.
   */
  private getSelected(
    options: FilterOption[]
  ): FilterOption[] {
    const result: FilterOption[] = [];

    const visit = (nodes: FilterOption[]) => {
       nodes.forEach( node => {
        if(node.selected){
          result.push(node);
        }

        if(node.children?.length) {
          visit(node.children);
        }
       });
    };

    visit(options);

    return result;
  }

   /**
   * Muestra todos los nombres.
   */
  private label(
    selected: FilterOption[]
  ): string {

    return selected
      .map(s => s.id)
      .join(', ');

  }

  /**
   * Muestra únicamente el total.
   */
  private count(
    selected: FilterOption[]
  ): string {

    return `${selected.length} seleccionados`;

  }

  /**
   * AUTO
   */
  private auto(
    selected: FilterOption[],
    max: number
  ): string[] {
    selected.reverse();
    const labels = selected
      .slice(0, max)
      .map(s => `${s.id}`);

    const remaining = selected.length - labels.length;

    if (remaining <= 0) {
      return labels;
    }

    return [...labels,`+${remaining}`];

  }
  /**
   * LABEL + COUNT
   */
  private labelPlusCount(
    selected: FilterOption[],
    max: number
  ): string[] {
    const labels = selected
      .slice(0, max)
      .map(s => s.label);

    const remaining = selected.length - labels.length;

    if (remaining <= 0) {
      return labels;
    }

    return [...labels,`+${remaining}`];
  }
}